import { createFileRoute } from '@tanstack/react-router'

import { Breadcrumbs } from '@/components/layout/breadcrumbs.tsx'
import { Attribute } from '@/features/attributes/types.ts'

import { AttributeForm } from '../-components/form.tsx'

export const Route = createFileRoute(
  '/_authenticated/settings/attributes/create/'
)({
  component: AttributeCreate,
})

function AttributeCreate() {
  const navigate = Route.useNavigate()
  const handleSubmitted = (attribute: Attribute) => {
    navigate({
      to: '/settings/attributes/edit/$attributeId',
      params: { attributeId: attribute.id },
    })
  }

  return (
    <>
      <Breadcrumbs
        items={[
          { name: 'Impostazioni' },
          {
            name: 'Attributi',
            to: `/settings/attributes`,
          },
          { name: 'Nuovo' },
        ]}
      />

      <AttributeForm onSubmitted={handleSubmitted} />
    </>
  )
}
